@let intermediaryStep = stepName() !== CopyResourceStep.COPY_RESOURCE;

<flx-modal
  [dismissible]="intermediaryStep"
  [showBack]="showBack()"
  (dismiss)="closeModal()"
  (back)="goToPreviousStep()"
  class="flx-ds"
  data-testid="copy-resource-modal-body"
>
  @if (intermediaryStep) {
    <div
      class="flx-modal-title"
      flxModalHeaderTitle
    >
      {{ title() }}
    </div>
  }

  @if (subtitle()) {
    <div
      class="mt-1 text-xs text-center text-neutral-500"
      flxModalHeaderSubtitle
    >
      {{ subtitle() }}
    </div>
  }

  <div class="flx-modal-body">
    @switch (stepName()) {
      @case (CopyResourceStep.SELECT_DESTINATION) {
        <flx-copy-resource-select-destination>
          <ng-container ngProjectAs="[resourceUsages]">
            <ng-container *ngTemplateOutlet="resourceUsagesTemplate"></ng-container>
          </ng-container>
        </flx-copy-resource-select-destination>
      }
      @case (CopyResourceStep.REVIEW_RESOURCES) {
        <flx-copy-resource-review-resources></flx-copy-resource-review-resources>
      }
      @case (CopyResourceStep.REVIEW_DEPENDENCIES) {
        <flx-copy-resource-review-dependencies
          (title)="title.set($event)"
          (subtitle)="subtitle.set($event)"
        ></flx-copy-resource-review-dependencies>
      }
      @case (CopyResourceStep.COPY_RESOURCE) {
        <flx-copy-resource-send-data-review-errors
          [successFn]="successFn"
          (close)="onCopySuccess()"
        ></flx-copy-resource-send-data-review-errors>
      }
    }
  </div>

  @if (intermediaryStep) {
    <div class="flx-modal-footer">
      @let hasResourcesToImport = !noNewResourcesToImport();

      <div class="flx-modal-footer__right">
        <button
          (click)="closeModal()"
          class="flx-ds secondary"
          data-testId="cancel-copy-button"
          flxButton
          type="button"
          variant="ghost"
        >
          Cancel
        </button>

        @if (hasResourcesToImport) {
          <button
            [disabled]="formInvalidCurrentStep() || loading()"
            (click)="goToNextStep()"
            class="flx-ds primary"
            data-testId="continue-button"
            flxButton
            icon="left"
          >
            Continue
            @if (loading()) {
              <flx-icon
                name="loading"
                class="stroke-blue-500 !h-6 !w-6"
              ></flx-icon>
            }
          </button>
        } @else {
          <button
            (click)="closeModal()"
            class="flx-ds primary"
            data-testId="exit-without-copy-button"
            flxButton
          >
            Exit without copying
          </button>
        }
      </div>
    </div>
  }
</flx-modal>

<ng-template #resourceUsagesTemplate>
  @if (totalUsedResources() > 0) {
    <flx-resource-usages-view-references
      [total]="totalUsedResources()"
      [view]="ResourceUsageView.USED_RESOURCES"
      (viewReferences)="openResourceUsagesModal(usedResources())"
    >
    </flx-resource-usages-view-references>
  } @else {
    <div class="text-[10px] text-neutral-500">
      This {{ displayResourceType() }} does not have any references yet.
    </div>
  }
</ng-template>
